/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelLegal = new Class({
  Extends: PanelYesNo,
  template: function () {
    var data = Object.assign({}, this.data, {
      showTerms: typeof this.data.meta.showTerms === 'boolean' ? this.data.meta.showTerms : true,
      showPrivacy: typeof this.data.meta.showPrivacy === 'boolean' ? this.data.meta.showPrivacy : true,
    })
    var privacy = Mustache.render(
      '{{#showTerms}}<p class="panel--legal__text">{{{ terms.text }}}</p>' +
        '<div class="clear"></div>' +
        '<a target="_blank" class="panel--legal__link" href="{{terms.linkURL}}">{{terms.linkText}}</a>{{/showTerms}}' +
        '{{#showPrivacy}}<p class="panel--legal__text">{{{ privacy.text }}}</p>' +
        '<div class="clear"></div>' +
        '<a target="_blank" class="panel--legal__link" href="{{privacy.linkURL}}">{{privacy.linkText}}</a>{{/showPrivacy}}',
      data
    )
    var base =
      '<div class="panel--wrapper panel--yesno panel--legal holds--data isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="panel--content">' +
      privacy +
      '            <div class="clear"></div>' +
      '            {% options %}' +
      '            <div class="clear"></div>' +
      '        </div>' +
      '        <div class="panel--overlay">' +
      '            <div class="icon--checkWrapper circle">' +
      '                <div class="check"></div>' +
      '            </div>' +
      '            <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" aria-hidden="true" class="icon--redoWrapper">' +
      '                <div class="redo"></div>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var option =
      '<div class="yesno--option option--{{ type }}" data-option-value="{{ type }}">' +
      '      <button type="button" class="option--content">' +
      '          <div class="option--text">{{ text }}</div>' +
      '          <div class="icon--checkWrapper dark atLeft">' +
      '              <div class="check"></div>' +
      '          </div>' +
      '      </button>' +
      '</div>'

    return { base: base, option: option }
  },
})
